import { Link, useLocation } from "wouter";
import { useGoogleAuth } from "@/hooks/useGoogleAuth";
import {
  LayoutDashboard,
  Package,
  MapPin,
  TrendingUp,
  Users,
  Menu,
  X,
  History,
  BarChart3,
  Building2,
  ChevronDown,
  ChevronRight,
  ClipboardList,
  FileText,
  DollarSign,
  Briefcase,
  Truck,
  ShoppingCart,
  Settings,
  Calculator,
  UserCog,
  Receipt,
  CreditCard,
  FileCheck,
  Banknote,
  Bell,
  Search,
  Landmark,
  FileSpreadsheet,
  Mail,
  Percent,
  Database,
  Wrench,
  Monitor,
  BookOpen,
  LayoutGrid,
  ScanSearch,
  BadgeDollarSign,
  Star,
  UserPlus,
  UsersRound,
  Building,
  SendToBack,
  Box,
  Tag,
  Printer,
  ArrowLeftRight,
  Ticket,
  Activity,
  AlertTriangle,
  Clock,
  ClipboardCheck,
  Plug,
  UploadCloud,
} from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { cn } from "@/lib/utils";
import { usePagePermissions } from "@/hooks/usePagePermissions";

// Definição dos grupos de menu
// roles: define quais roles fixos (admin/lider/operador) têm acesso ao grupo
// Para role "cliente", o acesso é controlado exclusivamente por hasAccess(item.path)
export const menuGroups = [
  {
    title: "Administrador",
    icon: UserCog,
    roles: ["admin"],
    items: [
      { icon: Building2, label: "Emitentes", path: "/emitentes", roles: ["admin"] },
      { icon: Users, label: "Usuários", path: "/users", roles: ["admin", "lider"] },
      { icon: FileText, label: "Log de Alterações", path: "/audit-log", roles: ["admin"] },
      { icon: Database, label: "View Banco", path: "/admin/database-view", roles: ["admin"] },
      { icon: Box, label: "Armazenamento", path: "/armazenamento", roles: ["admin"] },
      { icon: Calculator, label: "FECHAMENTOS - BOX", path: "/fechamentos-box", roles: ["admin"] },
      { icon: BarChart3, label: "OL - Análise de Viabilidade", path: "/ol-viabilidade", roles: ["admin"] },
      { icon: Bell, label: "Lembretes de Gestão", path: "/lembretes-gestao", roles: ["admin"] },
      { icon: Activity, label: "Processamento", path: "/processamento", roles: ["admin"] },
      { icon: Plug, label: "Integrações", path: "/integracoes", roles: ["admin", "cliente"] },
      { icon: UploadCloud, label: "Importação Box", path: "/importacao-box", roles: ["admin"] },
      { icon: UploadCloud, label: "Importação Monday Resolve", path: "/importacao-monday-resolve", roles: ["admin"] },
      { icon: UploadCloud, label: "Importação Monday Tratativas", path: "/importacao-monday-tratativa-inconformidade", roles: ["admin"] },
    ],
  },
  {
    title: "Logística",
    icon: Package,
    roles: ["admin", "lider", "operador"],
    items: [
      { icon: ClipboardList, label: "Fila", path: "/queue", roles: ["admin", "lider", "operador"] },
      { icon: History, label: "Histórico", path: "/history", roles: ["admin", "lider", "operador"] },
      { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard", roles: ["admin", "lider"] },
      { icon: LayoutDashboard, label: "Dashboard da Operação", path: "/dashboard-operacao", roles: ["admin"] },
      { icon: Package, label: "Produtos", path: "/products", roles: ["admin", "lider"] },
      { icon: MapPin, label: "Endereços", path: "/addresses", roles: ["admin", "lider"] },
      { icon: TrendingUp, label: "Produtividade", path: "/productivity", roles: ["admin", "lider"] },
      { icon: FileCheck, label: "Pedidos em Aberto", path: "/open-orders", roles: ["admin", "lider"] },
      { icon: MapPin, label: "Sugestão Endereçamento", path: "/address-suggestion", roles: ["admin", "lider"] },
      { icon: Package, label: "Movimentação Estoque", path: "/stock-movement", roles: ["admin", "lider"] },
      { icon: AlertTriangle, label: "Baixa por Dano e Extravio", path: "/baixa-dano-extravio", roles: ["admin"] },
      { icon: ArrowLeftRight, label: "Mov. por Endereços", path: "/address-movements", roles: ["admin", "lider"] },
      { icon: Monitor, label: "Checkout Eletrônico", path: "/checkout", roles: ["admin", "lider"] },
      { icon: BookOpen, label: "Gravar Pedidos", path: "/record-orders", roles: ["admin", "lider"] },
      { icon: LayoutGrid, label: "Cadastro de PO", path: "/workbenches", roles: ["admin", "lider"] },
      { icon: ScanSearch, label: "Search-Box", path: "/search-box", roles: ["admin", "lider"] },
      { icon: ScanSearch, label: "Inventário Cego", path: "/inventario-cego", roles: ["admin", "lider", "operador"] },
    ],
  },
  {
    title: "Fiscal / Financeiro",
    icon: DollarSign,
    roles: ["admin", "cliente"],
    items: [
      { icon: Receipt, label: "Contas a Pagar", path: "/accounts-payable", roles: ["admin"] },
      { icon: CreditCard, label: "Contas a Receber", path: "/accounts-receivable", roles: ["admin"] },
      { icon: CreditCard, label: "Crédito de Destinatários", path: "/creditos-destinatarios", roles: ["admin", "cliente"] },
      { icon: FileCheck, label: "Baixa Guiada de Comprovantes", path: "/baixa-guiada-comprovantes", roles: ["admin", "cliente"] },
      { icon: Landmark, label: "Conciliação Bancária", path: "/bank-reconciliation", roles: ["admin"] },
      { icon: Banknote, label: "Remessas Recebimento", path: "/bank-receipts", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Baixas Retorno", path: "/bank-return-settlements", roles: ["admin"] },
      { icon: Banknote, label: "Remessas Pagamento", path: "/bank-payments", roles: ["admin"] },
      { icon: Bell, label: "Config. Cobrança", path: "/billing-config", roles: ["admin"] },
      { icon: History, label: "Histórico Cobranças", path: "/billing-history", roles: ["admin"] },
      { icon: Search, label: "Fila de Revisão", path: "/review-queue", roles: ["admin"] },
      { icon: Landmark, label: "Contas Bancárias", path: "/bank-accounts", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Condições Pagamento", path: "/payment-terms", roles: ["admin"] },
      { icon: FileCheck, label: "Baixas Francesinha", path: "/francesinha", roles: ["admin", "cliente"] },
      { icon: Mail, label: "Carta de Correção", path: "/correction-letter", roles: ["admin"] },
      { icon: FileText, label: "Nota Complementar", path: "/complementary-invoice", roles: ["admin"] },
      { icon: FileText, label: "Emissor NF Avulsa", path: "/invoice-issuer" },
      { icon: History, label: "Histórico NF", path: "/invoice-history", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Faturas de Operação", path: "/faturas-operacao", roles: ["admin", "cliente"] },
    ],
  },
  {
    title: "Consultas",
    icon: Search,
    roles: ["admin", "lider"],
    items: [
      { icon: Search, label: "Consulta de Pedidos", path: "/somente-consulta-pedidos", roles: ["admin"] },
      { icon: Package, label: "Consulta de Produtos", path: "/somente-consulta-produtos", roles: ["admin", "lider"] },
      { icon: CreditCard, label: "Consulta de Contas a Receber", path: "/somente-consulta-contas-receber", roles: ["admin"] },
      { icon: Receipt, label: "Consulta de Contas a Pagar", path: "/somente-consulta-contas-pagar", roles: ["admin"] },
    ],
  },
  {
    title: "RH",
    icon: Briefcase,
    roles: ["admin"],
    items: [
      { icon: UserCog, label: "Cargos e Salários", path: "/positions", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Folha", path: "/payroll", roles: ["admin"] },
      { icon: CreditCard, label: "Benefícios", path: "/benefits", roles: ["admin"] },
      { icon: UserPlus, label: "Vagas", path: "/rh-vagas", roles: ["admin"] },
      { icon: UsersRound, label: "Banco de Talentos", path: "/rh-talentos", roles: ["admin"] },
      { icon: Building, label: "Controle de Departamento Pessoal", path: "/rh-departamento", roles: ["admin"] },
      { icon: ClipboardCheck, label: "Controle de Ponto", path: "/controle-ponto", roles: ["admin"] },
    ],
  },
  {
    title: "Cadastros",
    icon: FileText,
    roles: ["admin"],
    items: [
      { icon: Users, label: "Destinatários", path: "/recipients", roles: ["admin"] },
      { icon: Truck, label: "Transportadoras", path: "/carriers", roles: ["admin"] },
      { icon: Users, label: "Contatos", path: "/contacts", roles: ["admin"] },
      { icon: Package, label: "Cadastro Básico de Produto", path: "/cadastro-basico-produto", roles: ["admin", "cliente"] },
      { icon: Tag, label: "Cadastro de Etiquetas", path: "/cadastro-etiquetas", roles: ["admin"] },
    ],
  },
  {
    title: "Comercial",
    icon: ShoppingCart,
    roles: ["admin"],
    items: [
      { icon: FileText, label: "Orçamentos", path: "/quotes", roles: ["admin"] },
      { icon: Settings, label: "Config. Orçamento", path: "/quote-config", roles: ["admin"] },
      { icon: FileText, label: "Orçamento XML NFe", path: "/quote-xml", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Tabelas", path: "/price-tables", roles: ["admin"] },
      { icon: BadgeDollarSign, label: "Config. Comissões", path: "/comissoes-config", roles: ["admin"] },
      { icon: BadgeDollarSign, label: "Comissão por Ação de Venda", path: "/comissao-acao-venda", roles: ["admin", "cliente"] },
      { icon: BadgeDollarSign, label: "Comissões Oficiais", path: "/comissoes-oficiais", roles: ["admin", "cliente"] },
      { icon: Star, label: "Sales-Box (CRM 360)", path: "/sales-box", roles: ["admin", "cliente"] },
    ],
  },
  {
    title: "Utilitários Logísticos",
    icon: Truck,
    roles: ["admin"],
    items: [
      { icon: ClipboardList, label: "Agendamento Entradas", path: "/entry-schedule", roles: ["admin", "lider", "cliente"] },
      { icon: Package, label: "Recebimentos", path: "/logistics-receipts", roles: ["admin"] },
      { icon: Search, label: "Consulta Pedidos", path: "/order-search", roles: ["admin"] },
      { icon: FileSpreadsheet, label: "Tabela de Fretes", path: "/freight-table", roles: ["admin"] },
      { icon: SendToBack, label: "Controle de Expedição", path: "/expedicao", roles: ["admin"] },
      { icon: Box, label: "Pequenos Pacotes (MECOM-SED)", path: "/mecom-sed", roles: ["admin"] },
      { icon: UploadCloud, label: "Upload Vídeos MECOM", path: "/upload-videos-mecom", roles: ["admin", "cliente"] },
      { icon: UploadCloud, label: "Processamento de Etiquetas Externas", path: "/processamento-etiquetas-externas", roles: ["admin"] },
      { icon: Tag, label: "Template de Etiquetas", path: "/label-templates", roles: ["admin"] },
      { icon: Printer, label: "Imprimir Etiquetas", path: "/print-labels", roles: ["admin"] },
      { icon: Tag, label: "Tratamento Etiqueta Full", path: "/tratamento-etiqueta-volume-full", roles: ["admin"] },
    ],
  },
  {
    title: "Utilidades",
    icon: Wrench,
    roles: ["admin"],
    items: [
      { icon: ClipboardList, label: "Task Manager", path: "/task-manager", roles: ["admin"] },
      { icon: Ticket, label: "Resolve", path: "/resolve" },
      { icon: ClipboardList, label: "Tratamento de Inconformidade", path: "/tratativa-inconformidade" },
      { icon: Settings, label: "Config. Tipos Resolve", path: "/resolve-config", roles: ["admin"] },
    ],
  },
  {
    title: "Config. Fiscais",
    icon: Settings,
    roles: ["admin"],
    items: [
      { icon: FileText, label: "Natureza Operação", path: "/operation-nature", roles: ["admin"] },
      { icon: FileText, label: "Replicação Fiscal", path: "/fiscal-replication", roles: ["admin"] },
      { icon: FileCheck, label: "Certificado Digital", path: "/digital-certificate", roles: ["admin"] },
      { icon: Search, label: "Consulta NF Agendada", path: "/scheduled-invoice-query", roles: ["admin"] },
    ],
  },
  {
    title: "Impostos",
    icon: Calculator,
    roles: ["admin"],
    items: [
      { icon: Percent, label: "ICMS", path: "/tax-icms", roles: ["admin"] },
      { icon: Percent, label: "IPI", path: "/tax-ipi", roles: ["admin"] },
      { icon: Percent, label: "CBS - IBS", path: "/tax-cbs", roles: ["admin"] },
      { icon: Percent, label: "PIS - COFINS", path: "/tax-pis-cofins", roles: ["admin"] },
      { icon: Percent, label: "MVA-ST", path: "/tax-mva-st", roles: ["admin"] },
      { icon: Percent, label: "FCP", path: "/tax-fcp", roles: ["admin"] },
      { icon: Percent, label: "ISS", path: "/tax-iss", roles: ["admin"] },
    ],
  },
];

export function Sidebar() {
  const { user, checkAuth } = useGoogleAuth();
  const { hasAccess } = usePagePermissions();
  const [location] = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState<string[]>(["Administrador", "Logistica"]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [profileName, setProfileName] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const updateMyProfile = trpc.users.updateMyProfile.useMutation({
    onSuccess: async () => {
      await checkAuth();
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setIsProfileOpen(false);
      toast.success("Perfil atualizado.");
    },
    onError: (error) => toast.error(error.message),
  });

  const { data: notificacoesResolveData } = trpc.resolve.notificacoes.list.useQuery(
    { page: 1, pageSize: 1 },
    { enabled: !!user }
  );
  const { data: orcamentosEmRevisao = [] } = trpc.orcamentos.list.useQuery(
    { status: "reprovado" },
    { enabled: !!user }
  );
  const { data: pedidosEmRevisao = [] } = trpc.pedidos.listRevisao.useQuery(
    undefined,
    { enabled: !!user }
  );

  if (!user) return null;

  const notificacoesResolveNaoLidas = Number(notificacoesResolveData?.naoLidas ?? 0);
  const totalOrcamentosEmRevisao = (orcamentosEmRevisao as any[]).length;
  const totalPedidosEmRevisao = (pedidosEmRevisao as any[]).length;

  const toggleGroup = (title: string) => {
    setExpandedGroups((prev) =>
      prev.includes(title)
        ? prev.filter((t) => t !== title)
        : [...prev, title]
    );
  };

  const abrirPerfil = () => {
    setProfileName(user.name || "");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setIsProfileOpen(true);
  };

  const salvarPerfil = (event: React.FormEvent) => {
    event.preventDefault();
    const nameChanged = profileName.trim() !== (user.name || "");
    const passwordChanged = newPassword.length > 0 || confirmPassword.length > 0;
    if (!nameChanged && !passwordChanged) return toast.error("Nenhuma alteração informada.");
    if (passwordChanged && newPassword !== confirmPassword) return toast.error("A confirmação da nova senha não confere.");
    if (passwordChanged && newPassword.length < 6) return toast.error("A nova senha deve ter ao menos 6 caracteres.");
    updateMyProfile.mutate({
      name: nameChanged ? profileName.trim() : undefined,
      currentPassword: currentPassword || undefined,
      newPassword: passwordChanged ? newPassword : undefined,
    });
  };

  // Para admin/lider/operador: filtro por item.roles (controle fixo por role)
  // Para cliente: filtro exclusivamente por hasAccess(item.path) — sem item.roles
  const filteredGroups = menuGroups
    .map((group) => {
      let visibleItems;
      if (user.role === "admin") {
        // Admin vê tudo
        visibleItems = group.items;
      } else if (user.role === "cliente") {
        // Cliente: apenas itens liberados pelo admin via permissões de página
        visibleItems = group.items.filter((item) => hasAccess(item.path));
      } else {
        // lider/operador: filtro por item.roles
        visibleItems = group.items.filter((item) => item.roles.includes(user.role));
      }
      return { ...group, items: visibleItems };
    })
    .filter((group) => group.items.length > 0);

  // Filtro por searchTerm: filtra itens e grupos pelo termo digitado
  const searchedGroups = searchTerm.trim() === ""
    ? filteredGroups
    : filteredGroups
        .map((group) => ({
          ...group,
          items: group.items.filter((item) =>
            item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
            group.title.toLowerCase().includes(searchTerm.toLowerCase())
          ),
        }))
        .filter((group) => group.items.length > 0);

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white border border-gray-300 shadow-sm hover:bg-gray-50"
      >
        {isOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          "fixed top-0 left-0 h-full bg-gray-900 text-white w-64 z-40 transition-transform duration-300 ease-in-out flex flex-col",
          isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        )}
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-800">
          <h1 className="text-xl font-bold">Box - Warehouse</h1>
          <p className="text-sm text-gray-400 mt-1">
            {user.role === "admin"
              ? "Administrador"
              : user.role === "lider"
              ? "Líder"
              : user.role === "cliente"
              ? "Cliente"
              : "Operador"}
          </p>
          <div className="mt-3 flex items-center gap-2">
            <Link href="/resolve">
              <a
                className="relative flex h-8 w-8 items-center justify-center rounded-md bg-gray-800 text-gray-300 transition-colors hover:bg-gray-700 hover:text-white"
                title="Notificações do Resolve"
              >
                <Bell size={16} />
                {notificacoesResolveNaoLidas > 0 && (
                  <span className="absolute -right-1 -top-1 min-w-4 rounded-full bg-orange-500 px-1 text-center text-[10px] leading-4 text-white">
                    {notificacoesResolveNaoLidas > 99 ? "99+" : notificacoesResolveNaoLidas}
                  </span>
                )}
              </a>
            </Link>
            <Link href="/review-queue?tipo=orcamentos">
              <a
                className="relative flex h-8 w-8 items-center justify-center rounded-md bg-gray-800 text-gray-300 transition-colors hover:bg-gray-700 hover:text-white"
                title="Orçamentos em revisão"
              >
                <FileText size={16} />
                {totalOrcamentosEmRevisao > 0 && (
                  <span className="absolute -right-1 -top-1 min-w-4 rounded-full bg-red-500 px-1 text-center text-[10px] leading-4 text-white">
                    {totalOrcamentosEmRevisao > 99 ? "99+" : totalOrcamentosEmRevisao}
                  </span>
                )}
              </a>
            </Link>
            <Link href="/review-queue?tipo=pedidos">
              <a
                className="relative flex h-8 w-8 items-center justify-center rounded-md bg-gray-800 text-gray-300 transition-colors hover:bg-gray-700 hover:text-white"
                title="Pedidos em revisão"
              >
                <ClipboardCheck size={16} />
                {totalPedidosEmRevisao > 0 && (
                  <span className="absolute -right-1 -top-1 min-w-4 rounded-full bg-orange-500 px-1 text-center text-[10px] leading-4 text-white">
                    {totalPedidosEmRevisao > 99 ? "99+" : totalPedidosEmRevisao}
                  </span>
                )}
              </a>
            </Link>
          </div>
        </div>

        {/* Search */}
        <div className="px-4 py-2 border-b border-gray-800">
          <div className="relative">
            <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-500" />
            <input
              type="text"
              placeholder="Buscar módulo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-gray-800 text-sm text-white placeholder-gray-500 rounded-md pl-8 pr-3 py-1.5 outline-none focus:ring-1 focus:ring-orange-500"
            />
          </div>
        </div>

        {/* Navigation with collapsible groups */}
        <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
          {searchedGroups.map((group) => {
            const GroupIcon = group.icon;
            const isExpanded = expandedGroups.includes(group.title);
            const hasActiveItem = group.items.some(
              (item) => location === item.path || (item.path === "/queue" && location === "/")
            );

            return (
              <div key={group.title} className="mb-1">
                {/* Group header */}
                <button
                  onClick={() => toggleGroup(group.title)}
                  className={cn(
                    "flex items-center justify-between w-full px-3 py-2 rounded-lg transition-colors text-sm font-medium",
                    hasActiveItem
                      ? "bg-gray-800 text-orange-400"
                      : "text-gray-300 hover:bg-gray-800 hover:text-white"
                  )}
                >
                  <div className="flex items-center gap-2">
                    <GroupIcon size={18} />
                    <span>{group.title}</span>
                  </div>
                  {isExpanded ? (
                    <ChevronDown size={16} className="text-gray-500" />
                  ) : (
                    <ChevronRight size={16} className="text-gray-500" />
                  )}
                </button>

                {/* Group items */}
                {isExpanded && (
                  <div className="ml-4 mt-1 space-y-0.5">
                    {group.items.map((item) => {
                      const Icon = item.icon;
                      const isActive = location === item.path || (item.path === "/queue" && location === "/");
                      return (
                        <Link
                          key={item.path}
                          href={item.path}
                          onClick={() => setIsOpen(false)}
                        >
                          <a
                            className={cn(
                              "flex items-center gap-2 px-3 py-2 rounded-lg transition-colors text-sm",
                              isActive
                                ? "bg-orange-600 text-white"
                                : "text-gray-400 hover:bg-gray-800 hover:text-white"
                            )}
                          >
                            <Icon size={16} />
                            <span>{item.label}</span>
                          </a>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* User info */}
        <div className="p-4 border-t border-gray-800">
          <button type="button" onClick={abrirPerfil} className="flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-gray-800" title="Editar perfil">
            <div className="w-8 h-8 rounded-full bg-orange-600 flex items-center justify-center text-sm font-bold">
              {(user.name || user.email || "U").charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{user.name || user.email}</p>
              <p className="text-xs text-gray-400 truncate">{user.email}</p>
            </div>
            <Settings size={16} className="text-gray-500" />
          </button>
        </div>
      </aside>

      {isProfileOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-labelledby="perfil-title">
          <form onSubmit={salvarPerfil} className="w-full max-w-md rounded-lg bg-white p-6 text-gray-900 shadow-xl">
            <div className="mb-5 flex items-start justify-between gap-4">
              <div>
                <h2 id="perfil-title" className="text-lg font-semibold">Meu perfil</h2>
                <p className="mt-1 text-sm text-gray-500">Altere seu nome e, se desejar, sua senha de acesso.</p>
              </div>
              <button type="button" onClick={() => setIsProfileOpen(false)} className="rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900" aria-label="Fechar"><X size={20} /></button>
            </div>

            <label className="mb-4 block text-sm font-medium text-gray-700">Nome
              <input type="text" value={profileName} onChange={(event) => setProfileName(event.target.value)} maxLength={120} className="mt-1 h-10 w-full rounded-md border border-gray-300 px-3 outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500" />
            </label>

            <div className="border-t border-gray-200 pt-4">
              <p className="mb-3 text-sm font-medium text-gray-700">Alterar senha</p>
              <p className="mb-3 text-xs text-gray-500">Para contas que já possuem senha local, informe a senha atual. Contas Google sem senha local podem criar a primeira senha diretamente.</p>
              <label className="mb-3 block text-sm font-medium text-gray-700">Senha atual
                <input type="password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} autoComplete="current-password" className="mt-1 h-10 w-full rounded-md border border-gray-300 px-3 outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500" />
              </label>
              <label className="mb-3 block text-sm font-medium text-gray-700">Nova senha
                <input type="password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} autoComplete="new-password" minLength={6} className="mt-1 h-10 w-full rounded-md border border-gray-300 px-3 outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500" />
              </label>
              <label className="block text-sm font-medium text-gray-700">Confirmar nova senha
                <input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} autoComplete="new-password" minLength={6} className="mt-1 h-10 w-full rounded-md border border-gray-300 px-3 outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500" />
              </label>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button type="button" onClick={() => setIsProfileOpen(false)} disabled={updateMyProfile.isPending} className="h-10 rounded-md border border-gray-300 px-4 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50">Cancelar</button>
              <button type="submit" disabled={updateMyProfile.isPending} className="h-10 rounded-md bg-orange-600 px-4 text-sm font-medium text-white hover:bg-orange-700 disabled:cursor-not-allowed disabled:opacity-50">{updateMyProfile.isPending ? "Salvando..." : "Salvar"}</button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
